export enum FeatureFlags {
  DELETE_API = 'designControlsDeleteApi',
  SELF_SERVICE = 'integrationsSelfService',
}
